import React from 'react';
import PropTypes from 'prop-types';
import BaseSlider from 'components/BaseSlider';
import InstituteCard from 'components/cards/InstituteCard';
import { IntituteType } from 'propTypes/entities';
import Section from 'components/Section';
import Container from 'components/Container';

import styles from './styles.module.scss';

const MuseumsSection = ({ museums }) => {
	const currentYear = new Date().getFullYear();

	return (
		<Container gutter="noMobile">
			<Section
				title={`Юбилеи музеев – ${currentYear}`}
				className={styles.MuseumsSection}
				gutter="mobile"
			>
				<BaseSlider
					params={{
						spaceBetween: 20,
						slidesPerView: 'auto',
						breakpoints: {
							768: {
								spaceBetween: 20,
								slidesPerView: 2
							}
						}
					}}
					gutter="onlyMobile"
					showControlsButton
				>
					{museums.map((museum) => (
						<InstituteCard key={museum?._id} institute={museum} />
					))}
				</BaseSlider>
			</Section>
		</Container>
	);
};

MuseumsSection.propTypes = {
	museums: PropTypes.arrayOf(IntituteType)
};

export default MuseumsSection;
